export default "__VITE_ASSET__0a367731__"